import React, { useState } from "react";
import { Box, Container } from "@mui/material";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import HeroCst from "@components/HeroCst";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import { useTranslation } from "react-i18next";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import AnimationFadeIn from "@components/AnimationFadeIn";
import { PagesID } from "@utils/utilsConfigurations";
import { ServicesURL } from "@utils/utilsApi";
import AddEditFormCst from "@components/AddEditFormCst";
import { useFetchDataDetail } from "@hooks/useFetchDetail";
import useSWRMutation from "swr/mutation";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import { useAuth } from "@context/auth";
import { RolesDigitedEnum } from "@context/auth/types";

const EditDashboard: React.FC = () => {
  const { t } = useTranslation(["courses-digited-page"]); //cambiareeeeeeeeeeeee
  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
    description?: string;
  }>();
  const { dashboardId } = useParams();
  const { user } = useAuth();
  const isPO = user?.roles.includes(RolesDigitedEnum.PRODUCT_OWNER);

  const navigate = useNavigate();

  const { trigger } = useSWRMutation(
    ServicesURL.editDashboard,
    (url: string, params: any) => {
      return fetcher<any>(url, MethodType.PATCH, params.arg);
    },
  );
  const { columns, mutate, actionsForForms, dataDetail } = useFetchDataDetail(
    `${ServicesURL.getDashboard}?id=${dashboardId}${isPO ? "" : `&userId=${user?.id_user}`}`,
    PagesID["dashboard.corporate-association"],
  );

  const onSubmit = async (item: any) => {
    setOpenToast({ s: StatusEnum.LOADING, message: "loading" });

    const objToSend = {
      ...dataDetail.output[0],
      openLearningPlatformName: item.openLearningPlatformName,
    };

    try {
      await trigger(objToSend);
      setOpenToast({ s: StatusEnum.OK, message: "" });
    } catch (error) {
      setOpenToast(undefined);
      console.error(error);
    }

    mutate({ output: [item] });
  };

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-courses.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("edit.hero-title")}
          description={t("edit.hero-description")}
        />
        {columns && (
          <Box
            sx={{
              mt: "25px",
            }}
          >
            <AddEditFormCst
              row={dataDetail.output[0]}
              columns={columns}
              onSubmit={onSubmit}
              actionsForForms={actionsForForms}
              backButton={() => {
                navigate(`/dashboard/corporate-association`);
              }}
            />
          </Box>
        )}
      </Container>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("hero-title-add")}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
        }}
        status={openToast}
      />
    </AnimationFadeIn>
  );
};

export default EditDashboard;
